export enum XeroConnectionStatusEnum {
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
}

export enum XeroConnectionRequiredActionType {
  ACCOUNT_CODE_MAPPING_INCOMPLETE = 'ACCOUNT_CODE_MAPPING_INCOMPLETE',
  XERO_ORGANISATION_NOT_SELECTED = 'XERO_ORGANISATION_NOT_SELECTED',
  CONTACT_NOT_ACTIVE = 'CONTACT_NOT_ACTIVE',
}

export type XeroConnectionRequiredAction = {
  type: XeroConnectionRequiredActionType;
  url?: string;
};

type EntityItem = {
  id: string;
  name: string;
  taxRate?: string;
};

type ErrorEntityItem = {
  error: {
    code: string;
    description: string;
  };
};

export type XeroOrganisation = EntityItem;

export type XeroConnection = {
  connectionStatus: XeroConnectionStatusEnum;
  canUserConfigureConnection: boolean;
  xeroOrganisation?: XeroOrganisation;
  requiredActions?: XeroConnectionRequiredAction[];
};

export type XeroAccountCodeMappingItem = {
  category: EntityItem;
  xeroAccountCode?: XeroAccountItem;
} & Partial<ErrorEntityItem>;

export type XeroAccountItem = EntityItem & {
  code: string;
  description?: string;
};

export type XeroAccountItemPayload = {
  categoryId: string;
  xeroAccountCodeId: string;
};

export type XeroAccountCodeMappingErrorItem = Omit<
  XeroAccountItemPayload,
  'xeroAccountCodeId'
> &
  ErrorEntityItem;
